module.exports = __webpack_public_path__ + "static/media/distribute_tab_img.0b267b7b.jpg";